import React from 'react';
import CaseProgressVertical from '~components/caseProgressVertical';

export default function CasesDrawerContent() {
	return (
		<CaseProgressVertical />
	);
}